module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_m_piebald.58374299.png";